import type { Ref } from 'vue'

export type LeadNotice = {
  readonly type: 'success' | 'error'
  readonly id: number
}

// Результат отправки заявки (T17): «принята» — только после ответа сервера, при ошибке —
// сообщение с телефоном. Показывается компонентом LeadNotice в App.vue.
export const useLeadNotice = () => {
  const notice: Ref<LeadNotice | null> = useState<LeadNotice | null>('lead-notice', () => null)

  const show = (type: LeadNotice['type']): void => {
    notice.value = { type, id: Date.now() }
  }

  const clear = (): void => {
    notice.value = null
  }

  return { notice, show, clear }
}
